import { __decorate } from "tslib";
import { Message } from 'element-ui';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { devicesTypes, check, addDevices, editDevice, getCamera, tagList, sceneList, } from '@blade-sxp/device-management/api/device-management/index';
import { deviceGroupsTree, addBatchDelete } from '@blade-sxp/device-management/api/device-group-management/index';
import editModel from '@blade-sxp/device-management/components/edit-model.vue';
import basicLevelPlatform from '@blade-sxp/device-management/components/basic-level-platform.vue';
let default_1 = class default_1 extends Vue {
    dialogVisible;
    type;
    deviceId;
    addDeviceSuccess;
    changeType;
    param;
    scenes = '';
    loading = false;
    deviceType = [];
    tagOptions = [];
    defaultProps = {};
    keyAreaOptions = [];
    editType = '';
    dialogVisibleEdit = false;
    value1 = [];
    protocolType = [{ name: 'TCP' }, { name: 'UDP' }, { name: 'TCP Server' }];
    props = {
        value: 'name',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        emitPath: false, // 只返回该节点的值
    };
    value = '';
    leftTree;
    groupNameOption = [];
    groupArr = [];
    formData = {
        deviceCategory: '',
        deviceCode: '',
        deviceName: '',
        deviceSubCategory: '',
        deviceType: 'VN_RTSP',
        dir: '',
        externalBizFrom: '',
        port: '',
        groupName: '',
        groupId: '',
        ip: '',
        password: '',
        playBackId: '',
        playBackPlatForm: '',
        protocolType: 'TCP',
        username: '',
        point: '',
        remark: '',
        rtspAddress: '',
        vertices: '',
        latitude: '',
        longitude: '',
        scenes: [],
        tags: [],
    };
    platformPrograss = {
        stepIndex: 0,
        steps: [
            {
                disabled: true,
            },
            {
                disabled: true,
            },
        ],
    };
    btnStatus = ''; // 按钮状态
    cascaderInfo = {
        label: '',
        value: '',
    };
    platformDeviceData = {
        accessPlatform: '',
        groupName: '',
        deviceList: [],
        notes: '',
        deviceCode: '',
        deviceName: '',
        platformDeviceId: '',
        platformId: '',
    };
    get rules() {
        return {
            rtspAddress: [{ required: true, message: `${this.$t('device.pleaseEnterURL')}`, trigger: ['blur', 'change'] }],
            deviceName: [{ required: true, message: `${this.$t('device.pleaseEnterDeviceName')}`, trigger: 'blur' }],
            username: [{ required: true, message: `${this.$t('pleaseEnterusername')}`, trigger: 'blur' }],
            protocolType: [{ required: true, message: `${this.$t('pleaseEnterProtocolType')}`, trigger: 'change' }],
            password: [{ required: true, message: `${this.$t('pleaseEnterPassword')}`, trigger: 'blur' }],
            groupName: [{ required: true, message: `${this.$t('device.pleaseSelectDeviceOrganisation')}`, trigger: 'change' }],
            type: [{ required: true, message: `${this.$t('device.pleaseSelectDeviceType')}`, trigger: 'change' }],
            deviceCategory: [{ required: true, message: `${this.$t('device.pleaseSelectDeviceBigCategory')}`, trigger: 'blur' }],
            ip: [
                {
                    required: true,
                    message: this.$t('device.IPAddress'),
                    trigger: ['blur', 'change'],
                    validator: (rule, value, callback) => {
                        if (!/([0-9]\.?)+$/.test(this.formData.ip)) {
                            return callback(new Error(this.$t('device.IPAddress').toString()));
                        }
                        callback();
                    },
                },
            ],
            port: [
                {
                    required: true,
                    message: this.$t('device.port'),
                    trigger: ['blur', 'change'],
                    validator: (rule, value, callback) => {
                        if (!/[0-9]{1,6}$/.test(this.formData.port) || Number(this.formData.port) < 0 || Number(this.formData.port) > 65535) {
                            return callback(new Error(this.$t('device.Port').toString()));
                        }
                        callback();
                    },
                },
            ],
        };
    }
    get shouldDisable() {
        if (this.type === 'view') {
            return true;
        }
        else {
            return false;
        }
    }
    get getProtocolType() {
        if (this.formData.deviceType === 'VN_ONVIF') {
            return [{ name: 'TCP' }, { name: 'UDP' }, { name: 'TCP Server' }];
        }
        else {
            return [{ name: 'TCP' }, { name: 'UDP' }];
        }
    }
    changeStepIndex(val) {
        this.btnStatus = val;
        if (val === 'add') {
            this.platformPrograss.stepIndex = 0;
        }
        else {
            this.platformPrograss.stepIndex = 1;
        }
    }
    changeDeviceType() {
        this.formData.protocolType = 'TCP';
    }
    // 提交平台设备数据
    submitPlatformDevice() {
        if (this.type === 'view') {
            this.changeType();
            this.btnStatus = 'edit';
            this.$refs.dialog.scrollTo(0, 0);
        }
        else {
            const { valid } = this.$refs.platformDeviceBoxRef.$refs.platfromDeviceRef.validParams();
            const type = this.type;
            switch (type) {
                case 'add':
                    valid && this.addPlateformDevice();
                    break;
                case 'edit':
                    this.editPlateformDevice();
                    break;
                case 'view':
                    this.editPlateformDevice();
                    break;
            }
        }
    }
    // 添加平台下级平台设备
    addPlateformDevice() {
        // TODO 接口调试
        const param = this.getPlatformDeviceParam();
        addBatchDelete(param).then((res) => {
            this.$message({
                message: `${this.$t('success')}`,
                type: 'success',
            });
            this.addDeviceSuccess(true); // 更新列表数据
            this.$emit('update:dialogVisible', false);
        });
        // this.addDeviceSuccess(); // 更新列表数据
    }
    // 编辑下级平台设备
    editPlateformDevice() {
        // TODO 接口调试
        const param = this.getPlatformDeviceParam();
        editDevice(param, String(this.deviceId))
            .then((res) => {
            this.$message({
                message: `${this.$t('success')}`,
                type: 'success',
            });
            this.addDeviceSuccess(); // 更新列表数据
        })
            .finally(() => {
            this.$emit('update:dialogVisible', false);
        });
        // this.addDeviceSuccess(); // 更新列表数据
    }
    // 处理已选设备列表
    getDeviceListArr(deviceList) {
        const configDeviceList = this.$refs.platformDeviceBoxRef.configDeviceList;
        let curList = [];
        configDeviceList.forEach((it) => {
            deviceList.forEach((va) => {
                if (it.deviceCode === va && !it.addFlag) {
                    curList.push({ deviceCode: it.deviceCode, deviceName: it.deviceName });
                }
            });
        });
        const OptionalChecked = this.$refs.platformDeviceBoxRef.$refs.platfromDeviceRef
            .newOptionalChecked;
        OptionalChecked.forEach((it) => {
            curList.forEach((em) => {
                if (it.deviceCode === em.deviceCode) {
                    em.deviceName = it.deviceName;
                }
            });
        });
        return curList;
    }
    getPlatformDeviceParam() {
        // 整理创建下级平台设备参数 、、TODO
        const { formData } = this.$refs.platformDeviceBoxRef.$refs.platfromDeviceRef.validParams();
        const param = {
            deviceCategory: 'senseKeeper',
            deviceType: this.formData.deviceType,
            deviceCode: formData.deviceCode,
            baseDeviceInfoList: this.getDeviceListArr(formData.deviceList),
            deviceName: formData.deviceName,
            gb28181Config: {
                cmsPlatformId: 0,
                playBackId: '',
                playBackPlatForm: '',
                deviceCode: formData.deviceCode,
                deviceId: formData.platformDeviceId,
                platformId: formData.accessPlatform,
            },
            groupId: this.cascaderInfo?.value,
            groupName: this.cascaderInfo?.label,
            remark: formData.notes,
        };
        return param;
    }
    handlePrevious() {
        this.platformPrograss.stepIndex = 0;
    }
    handleNext() {
        const type = this.btnStatus;
        switch (type) {
            case 'view':
                this.btnStatus = 'edit';
                break;
            default:
                this.platformPrograss.stepIndex = 1;
        }
    }
    // 单选选中平台
    selectedPlatform() {
        if (this.type !== 'add') {
            return;
        }
        const stepIndex = 0;
        const prograss = this.platformPrograss;
        prograss.stepIndex = stepIndex;
        prograss.steps[stepIndex].disabled = false;
    }
    // 删除了勾选的平台
    deleteCheckedPlatform() {
        this.platformPrograss.steps[0].disabled = true;
    }
    onCascaderChange(info) {
        this.cascaderInfo = info;
    }
    getDevice() {
        if (this.type !== 'add' && this.deviceId) {
            this.loading = true;
            getCamera(String(this.deviceId)).then((res) => {
                this.formData = JSON.parse(JSON.stringify(res));
                const deviceType = res?.deviceType;
                if (deviceType === 'VP_GB28181_STD') {
                    this.platformDeviceData = {
                        accessPlatform: res?.platformId,
                        deviceName: res?.deviceName,
                        deviceList: [],
                        groupName: res?.groupId,
                        deviceCode: res?.deviceCode,
                        notes: res?.remark,
                        platformDeviceId: res.platformDeviceId,
                    };
                    this.cascaderInfo.value = res?.groupId;
                    this.cascaderInfo.label = res?.groupName;
                }
                this.formData.scenes = [];
                this.formData.tags = [];
                if (this.formData.longitude) {
                    if (Number.isInteger(Number(res.longitude))) {
                        this.formData.longitude = Number(res.longitude).toFixed(6);
                    }
                }
                if (this.formData.latitude) {
                    if (Number.isInteger(Number(res.latitude))) {
                        this.formData.latitude = Number(res.latitude).toFixed(6);
                    }
                }
                res.scenes.map((item) => {
                    this.scenes = String(item.id);
                    // this.formData.scenes.push(String(item.id));
                });
                res.tags.map((item) => {
                    this.formData.tags.push(String(item.id));
                });
                this.getTree();
            });
        }
        else {
            this.getTree();
        }
    }
    changeLabel(res) {
        this.formData.tags = [];
        res.map((item) => {
            this.formData.tags.push(item[0]);
        });
    }
    changeKeyArea(res) {
        this.formData.scenes = [res];
    }
    getTagList() {
        let param = {
            page: 1,
            size: 50,
        };
        tagList(param).then((res) => {
            this.tagOptions = res.list ?? [];
        });
    }
    getSceneList() {
        let param = {
            page: 1,
            size: 50,
        };
        sceneList(param).then((res) => {
            this.keyAreaOptions = res.list ?? [];
        });
    }
    get returnTitle() {
        if (this.type === 'edit') {
            return `${this.$t('editDevice')}`;
        }
        else if (this.type === 'view') {
            return `${this.$t('deviceDetails')}`;
        }
        else {
            return `${this.$t('deviceAdd')}`;
        }
    }
    changeSelect(e) {
        this.formData.groupId = String(this.groupNameOption.find((item) => {
            return item.name === String(e);
        })?.id);
    }
    getTree() {
        this.loading = true;
        deviceGroupsTree({ excludeUngrouped: true })
            .then((res) => {
            let deviceGroupsTreedData = res.tree;
            this.recursiveFunction(res.tree);
            this.groupNameOption = this.dealAreaTree(deviceGroupsTreedData);
        })
            .finally(() => {
            this.loading = false;
        });
    }
    recursiveFunction(trees) {
        let that = this;
        const getStr = function (list) {
            list.forEach(function (row) {
                if (row.children) {
                    that.groupArr.push(row);
                    getStr(row.children);
                }
            });
        };
        getStr(trees);
    }
    handleChange() {
        this.formData.groupId = String(this.groupArr.find((item) => {
            return item.name === this.formData.groupName;
        })?.id);
        this.$refs.queueReportCascader.dropDownVisible = false;
    }
    mounted() {
        // this.getTree();
        this.getTypeList();
        this.getDevice();
        this.getTagList();
        this.getSceneList();
    }
    getTypeList() {
        devicesTypes().then((res) => {
            this.deviceType = res;
        });
    }
    handleEdit(type) {
        this.editType = type;
        this.dialogVisibleEdit = true;
    }
    handleClose() {
        this.$emit('update:dialogVisible', false);
    }
    addDevice() {
        addDevices(this.param)
            .then((res) => {
            this.addDeviceSuccess(true);
            this.handleClose();
            this.$message({
                message: `${this.$t('deviceAddSuccess')}`,
                type: 'success',
            });
        })
            .finally(() => {
            this.loading = false;
        });
    }
    addSuccess(type) {
        if (type === 'keyArea') {
            this.getSceneList();
        }
        else {
            this.getTagList();
        }
    }
    editDevice() {
        editDevice(this.param, String(this.deviceId)).then((res) => {
            this.addDeviceSuccess();
            this.$message({
                message: `${this.$t('editSuccess')}`,
                type: 'success',
            });
            this.handleClose();
        });
    }
    // 处理地区树数据结构
    dealAreaTree(tree) {
        const newTree = tree.map((i) => {
            let children = i.children;
            if ((children && children.length === 0) || !children) {
                delete i.children;
            }
            else {
                this.dealAreaTree(children);
            }
            return i;
        });
        return newTree;
    }
    checkDevice() {
        this.loading = true;
        let param = {
            deviceType: this.formData.deviceType,
            externalBizFrom: '',
            ip: this.formData.ip,
            password: this.formData.password,
            port: this.formData.port,
            protocolType: this.formData.protocolType,
            rtspAddress: this.formData.rtspAddress,
            username: this.formData.username,
            deviceCode: null,
        };
        check(param)
            .then((res) => {
            if (res.ready) {
                if (this.type === 'add') {
                    this.addDevice();
                }
            }
            else {
                Message.error(`${this.$t('connectionFaild')}`);
            }
        })
            .finally(() => {
            this.loading = false;
        });
    }
    submitData() {
        this.$emit('update:dialogVisible', false);
        this.$refs.deviceForm.resetFields();
    }
    putParam() {
        this.param = {
            deviceCategory: this.formData.deviceCategory,
            deviceCode: this.formData.deviceCode,
            deviceName: this.formData.deviceName,
            deviceSubCategory: this.formData.deviceSubCategory,
            deviceType: this.formData.deviceType,
            dir: this.formData.dir,
            externalBizFrom: this.formData.externalBizFrom,
            groupId: this.formData.groupId,
            groupName: this.formData.groupName,
            scenes: this.formData.scenes,
            tags: this.formData.tags,
            onvifConfig: {
                ip: this.formData.ip,
                password: this.formData.password,
                playBackId: this.formData.playBackId,
                playBackPlatForm: this.formData.playBackPlatForm,
                port: this.formData.port,
                protocolType: this.formData.protocolType,
                username: this.formData.username,
            },
            point: this.formData.point,
            remark: this.formData.remark,
            rtspConfig: {
                playBackId: this.formData.playBackId,
                playBackPlatForm: this.formData.playBackPlatForm,
                rtspAddress: this.formData.rtspAddress,
                protocolType: this.formData.protocolType,
            },
            vertices: '',
            latitude: String(this.formData.latitude),
            longitude: String(this.formData.longitude),
        };
    }
    returnNumLen(num) {
        let res = String(num).split('.');
        let len = String(res[1]).split('').length;
        return len;
    }
    submit() {
        if (this.type === 'view') {
            this.changeType();
            this.$refs.dialog.scrollTo(0, 0);
        }
        else {
            const form = this.$refs.deviceForm;
            form.validate((valid) => {
                if (valid) {
                    if (this.formData.longitude) {
                        if (!this.formData.latitude) {
                            Message.error(`${this.$t('latitudeErr')}`);
                            return;
                        }
                        if (!/^(-|\+)?\d+(\.\d+)?$/.test(this.formData.longitude)) {
                            Message.error(`${this.$t('longitudeNumErr')}`);
                            return;
                        }
                        if (Number(this.formData.longitude) > 180 || Number(this.formData.longitude) < -180) {
                            Message.error(`${this.$t('longitudeNumErr')}`);
                            return;
                        }
                        if (Number.isInteger(Number(this.formData.longitude))) {
                            this.formData.longitude = Number(this.formData.longitude).toFixed(6);
                        }
                        else {
                            if (this.returnNumLen(Number(this.formData.longitude)) > 6) {
                                Message.error(`${this.$t('longitudeNumErr')}`);
                                return;
                            }
                        }
                    }
                    if (this.formData.latitude) {
                        if (!this.formData.longitude) {
                            Message.error(`${this.$t('longitudeErr')}`);
                            return;
                        }
                        if (!/^(-|\+)?\d+(\.\d+)?$/.test(this.formData.latitude)) {
                            Message.error(`${this.$t('latitudeNumErr')}`);
                            return;
                        }
                        if (Number(this.formData.latitude) > 90 || Number(this.formData.latitude) < -90) {
                            Message.error(`${this.$t('latitudeNumErr')}`);
                            return;
                        }
                        if (Number.isInteger(Number(this.formData.latitude))) {
                            this.formData.latitude = Number(this.formData.latitude).toFixed(6);
                        }
                        else {
                            if (this.returnNumLen(Number(this.formData.latitude)) > 6) {
                                Message.error(`${this.$t('latitudeNumErr')}`);
                                return;
                            }
                        }
                    }
                    if (this.formData.tags.length > 10) {
                        Message.error(`${this.$t('tagsLenErr')}`);
                        return;
                    }
                    this.putParam();
                    if (this.type === 'add') {
                        this.checkDevice();
                    }
                    else {
                        if (this.formData.groupName === 'Ungrouped Device') {
                            Message.error(`${this.$t('ungroupedErr')}`);
                            return;
                        }
                        this.editDevice();
                    }
                }
            });
        }
    }
};
__decorate([
    Prop()
], default_1.prototype, "dialogVisible", void 0);
__decorate([
    Prop()
], default_1.prototype, "type", void 0);
__decorate([
    Prop()
], default_1.prototype, "deviceId", void 0);
__decorate([
    Prop()
], default_1.prototype, "addDeviceSuccess", void 0);
__decorate([
    Prop()
], default_1.prototype, "changeType", void 0);
__decorate([
    Watch('type', { immediate: true })
], default_1.prototype, "changeStepIndex", null);
default_1 = __decorate([
    Component({
        name: 'model',
        components: {
            editModel,
            basicLevelPlatform,
        },
        i18n: {
            messages: {
                en: {
                    previous: 'Previous',
                    next: 'Next',
                    accessType: 'Protocol Type',
                    inputRule: 'Please enter task name',
                    protocolType: 'Type',
                    deviceName: 'Device name',
                    groupName: 'Group name',
                    type: 'Type',
                    url: 'URL',
                    playbackPlatform: 'Playback platform',
                    playbackID: 'Playback ID',
                    deviceID: 'Device ID',
                    deviceCode: 'Device Code',
                    notes: 'Notes',
                    edit: 'edit',
                    confirm: 'Confirm',
                    cancel: 'Cancel',
                    editDevice: 'Edit Device',
                    deviceDetails: 'Device Details',
                    pleaseSelect: 'Please select',
                    deviceAdd: 'Add Device',
                    RTSP: 'Direct camera /RTSP',
                    ONVIF: 'Direct camera /ONVIF',
                    connectionFaild: 'Connection failed, please check connection parameters',
                    deviceAddSuccess: 'Add Device Success',
                    editSuccess: 'Edit Device Success',
                    username: 'Subordinate platform username',
                    pleaseEnterusername: 'please Enter Username',
                    pleaseEnterPassword: 'please Enter Password',
                    password: 'Subordinate platform password',
                    port: 'Port number',
                    ip: 'IP',
                    label: 'Label',
                    keyArea: 'Key area',
                    longitude: 'Longitude',
                    latitude: 'Latitude',
                    testUrl: 'Please enter the correct RTSP address',
                    ungroupedErr: 'Group parameter is empty',
                    pleaseEnterProtocolType: 'Please select protocol type',
                    longitudeErr: 'Longitude cannot be empty',
                    latitudeErr: 'Latitude cannot be empty',
                    longitudeNumErr: 'Please enter the correct longitude',
                    latitudeNumErr: 'Please enter the correct latitude',
                    tagsLenErr: 'Select up to 10 labels',
                    tcp: 'TCP',
                    udp: 'UDP',
                    bearer: 'Transport Layer Protocol',
                },
                zh: {
                    previous: '上一步',
                    next: '下一步',
                    accessType: '协议类型',
                    ungroupedErr: '分组字段为空',
                    connectionFaild: '连接失败，请检查连接参数',
                    editSuccess: '修改成功',
                    editDevice: '设备编辑',
                    deviceCode: '设备编号',
                    deviceDetails: '设备详情',
                    inputRule: '请输入任务名称',
                    protocolType: '协议类型',
                    deviceName: '设备名称',
                    groupName: '组织名称',
                    type: '类型',
                    url: '网址',
                    edit: '修改',
                    username: '用户名',
                    password: '密码',
                    pleaseEnterusername: '请输入用户名',
                    pleaseEnterPassword: '请输入密码',
                    playbackPlatform: '播放平台',
                    playbackID: '平台ID',
                    deviceID: '设备ID',
                    notes: '备注',
                    confirm: '确定',
                    cancel: '取消',
                    pleaseSelect: '请选择',
                    deviceAdd: '添加设备',
                    deviceAddSuccess: '添加设备成功',
                    RTSP: 'Direct camera /RTSP',
                    ONVIF: 'Direct camera /ONVIF',
                    portInput: '必须为0-655535的整数',
                    port: '端口号',
                    ip: 'IP地址（IPv4/IPv6）',
                    label: '标签',
                    keyArea: '重点领域',
                    longitude: '经度',
                    latitude: '纬度',
                    testUrl: '请输入正确的RTSP地址',
                    pleaseEnterProtocolType: '请选择',
                    longitudeErr: '经度不能为空',
                    latitudeErr: '纬度不能为空',
                    longitudeNumErr: '请输入正确的经度',
                    latitudeNumErr: '请输入正确的纬度',
                    tagsLenErr: '最多选择10个标签',
                    tcp: 'TCP',
                    udp: 'UDP',
                    bearer: '传输层协议',
                },
            },
        },
    })
], default_1);
export default default_1;
